
export enum HexColorCode {
  White = '#FFF',
  white = '#FFF',

  Black = '#000',
  black = '#000',

  Red = '#FF0000',
  red = '#FF0000',

  RubineRed = '#D10056',
  rubineRed = '#D10056',

  Blue = '#0000FF',
  blue = '#0000FF',

  PacificBlue = '#1CA9C9',
  pacificBlue = '#1CA9C9',

  Green = '#00A83E',
  green = '#00A83E',

  Yellow = '#FFFF00',
  yellow = '#FFFF00',

  SunsetYellow = '#FFC922',
  sunsetYellow = '#FFC922',

  Orange = '#FF5A1F',
  orange = '#FF5A1F',

  Purple = '#800080',
  purple = '#800080',

  DeepPurple = '#5A2DFF',
  deepPurple = '#5A2DFF',

  Turquoise = '#00C7CF',
  turquoise = '#00C7CF',

  Gray = '#808080',
  gray = '#808080',
}

const normalizedColorSwatches: Record<string, string> = {
  white: HexColorCode.white,
  black: HexColorCode.black,
  red: HexColorCode.red,
  rubinered: HexColorCode.rubineRed,
  blue: HexColorCode.blue,
  pacificblue: HexColorCode.pacificBlue,
  green: HexColorCode.green,
  yellow: HexColorCode.yellow,
  sunsetyellow: HexColorCode.sunsetYellow,
  orange: HexColorCode.orange,
  purple: HexColorCode.purple,
  deeppurple: HexColorCode.deepPurple,
  turquoise: HexColorCode.turquoise,
  ombreblue: 'linear-gradient(135deg, #69B7E3 0%, #184A8B 100%)',
  blackblue: 'linear-gradient(135deg, #000000 0%, #000000 50%, #0067C5 50%, #0067C5 100%)',
  gray: HexColorCode.gray,
  grey: HexColorCode.gray,
};

export const getColorSwatch = (colorName: string): string => {
  const normalizedColorName = colorName.toLowerCase().replace(/[^a-z0-9]/g, '');
  return normalizedColorSwatches[normalizedColorName] ?? '#D3D3D3';
};
